<template>
  <div class="flex items-center flex-wrap">
    <div class="w-full flex flex-col">
      <div v-if="order.status === $page.constants.order.statuses.placed.value && order.payment_method === $page.constants.order.payment_methods.card.value" class="flex flex-col items-start text-base mb-8">
        <span class="font-semibold">Ați întâmpinat probleme la plată?</span>
        <inertia-link  :href="route('shop.checkout.mobilpay.retry', { order: order.id })" class="btn-gray mt-2">Încercați din nou</inertia-link>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <h1 class="font-bold text-xl mb-2">Detalii comandă</h1>
          <div class="flex flex-row">
            <div class="flex flex-col mr-6">
              <span class="text-gray-700">Status</span>
              <span class="text-gray-700">Plasată pe</span>
              <span class="text-gray-700">Metoda de plată</span>
            </div>
            <div class="flex flex-col">
              <span>{{ status.text }}</span>
              <span>{{ order.formatted_created_at }}</span>
              <span>{{ paymentMethod.text }}</span>
            </div>
          </div>
        </div>
        <div>
          <h1 class="font-bold text-xl mb-2">Informații de contact</h1>
          <div class="flex flex-row">
            <div class="flex flex-col mr-6">
              <span class="text-gray-700">Email</span>
              <span class="text-gray-700">Telefon</span>
            </div>
            <div class="flex flex-col">
              <span>{{ order.user.email }}</span>
              <span>{{ order.user.phone_number }}</span>
            </div>
          </div>
        </div>
        <div>
          <h1 class="font-bold text-xl mb-2">Informații facturare</h1>
          <div class="flex flex-row">
            <div class="flex flex-col mr-6">
              <span class="text-gray-700">Nume</span>
              <span class="text-gray-700">Telefon</span>
              <span v-if="order.billing_company && order.billing_cif" class="text-gray-700">Companie</span>
              <span v-if="order.billing_company && order.billing_cif" class="text-gray-700">CIF</span>
              <span class="text-gray-700">Address</span>
            </div>
            <div class="flex flex-col">
              <span>{{ order.billing_first_name }} {{ order.billing_last_name }}</span>
              <span>{{ order.billing_phone_number }}</span>
              <span v-if="order.billing_company && order.billing_cif">{{ order.billing_company }}</span>
              <span v-if="order.billing_company && order.billing_cif">{{ order.billing_cif }}</span>
              <span>{{ order.billing_address }}, {{ order.billing_postal_code}}, {{ order.billing_city }}</span>
            </div>
          </div>
        </div>
        <div>
          <h1 class="font-bold text-xl mb-2">Informații livrare</h1>
          <!-- pending changes for when new types of delivery are implemented  -->
          <div class="flex flex-row">
            <div class="flex flex-col mr-6">
              <span class="text-gray-700">Metoda de livrare</span>
            </div>
            <div class="flex flex-col">
              <span>{{ deliveryOption.text }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col mt-4">
        <h1 class="font-bold text-xl mb-2">Produse</h1>
        <div v-for="(item,index) in order.order_items" :key="index" class="flex items-center py-2">
          <div class="w-3/4 flex flex-row items-center">
            <img :src="item.lot.auction_listing_image" class="w-16 h-16 mr-2" :alt="`Image of ${item.lot.title}`" />
            <div class="flex flex-col">
              <span>{{ item.lot.title }}</span>
              <span class="text-gray-700">
                <span v-for="(artist,index) in item.lot.artists" :key="index">
                    <span v-if="artist.firstname">{{ artist.firstname }} {{ artist.lastname }}</span><span v-else>{{artist.name}}</span><span v-if="index != item.lot.artists.length - 1">, </span>
                </span>
                <div v-if="!item.lot.artists && item.lot.old_artist">
                    {{item.lot.old_artist}}
                </div>
              </span>
            </div>   
          </div>
          <div class="flex flex-row items-center justify-end w-1/4">
            <span class="font-bold">&euro; {{ item.lot.formatted_shop_price }}</span>
          </div>
        </div>
      </div>

      <div class="flex flex-1 justify-end">
        <div class="flex flex-col">
            <span class="text-xl mb-2 self-end">
              Total:
              <span class="font-bold">&euro; {{ order.formatted_order_total }}</span>
            </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Layout from '@/Shared/Layout'
import AccountLayout from '@/Shared/Account/Layout'

export default {
  metaInfo() {
    return {
      title: `Comanda ${this.order.id}`,
      meta: [ 
        { name: 'robots', content: 'noindex, nofollow, nosnippet, noarchive' },
        { name: 'googlebot', content: 'noindex, nofollow, nosnippet, noarchive' }
      ]
    }
  },
  layout: (h, page) => {
    return h(Layout, [
      h(AccountLayout, [page]),
    ])
  },
  props: {
    order: {
      type: Object
    } 
  },
  components: {
    AccountLayout,
    Layout,
  },
  computed: {
    status() {
      return Object.values(this.$page.constants.order.statuses).filter( (status) => {
        return status.value == this.order.status
      })[0]
    },
    paymentMethod() {
      return Object.values(this.$page.constants.order.payment_methods).filter( (status) => {
        return status.value == this.order.payment_method
      })[0]
    },
    deliveryOption() {
      return Object.values(this.$page.constants.order.delivery_options).filter( (status) => {
        return status.value == this.order.delivery_option
      })[0]
    }
  }
}
</script>
